import { instance } from "api/apiBase";
import { normalizeFile, normalizeFilename } from "shared/utils";

export const uploadFilesToS3 = async (files: File[]) => {
  return Promise.all(
    files.map(async (file) => {
      const queryParams = new URLSearchParams({
        filename: normalizeFilename(file.name),
        type: file.type
      }).toString();

      const { data: presignData } = await instance.get<{ url: string }>(
        `/portal/v1/boom_screen/assets/presign?${queryParams}`
      );

      const s3Response = await fetch(presignData.url, {
        method: "PUT",
        body: normalizeFile(file),
        mode: "cors"
      });

      const uploadedUrl = s3Response.url.split("?")[0];

      return uploadedUrl;
    })
  );
};
